// OkrCompletionTimeWidget.tsx
import React from 'react';
import { Column } from '@ant-design/plots';

interface OkrCompletionTimeWidgetProps {
    rowSpan?: number;
    colSpan?: number;
}

const OkrCompletionTimeWidget: React.FC<OkrCompletionTimeWidgetProps> = () => {
    // Dummy data
    const data = [
        { quarter: 'Q1', type: 'GELİŞİM OKR', value: 150 },
        { quarter: 'Q1', type: 'BİREYSEL OKR', value: 210 },
        { quarter: 'Q1', type: 'TAKIM OKR', value: 70 },
        { quarter: 'Q2', type: 'GELİŞİM OKR', value: 140 },
        { quarter: 'Q2', type: 'BİREYSEL OKR', value: 340 },
        { quarter: 'Q2', type: 'TAKIM OKR', value: 80 },
        { quarter: 'Q3', type: 'GELİŞİM OKR', value: 150 },
        { quarter: 'Q3', type: 'BİREYSEL OKR', value: 350 },
        { quarter: 'Q3', type: 'TAKIM OKR', value: 80 },
        { quarter: 'Q4', type: 'GELİŞİM OKR', value: 100 },
        { quarter: 'Q4', type: 'BİREYSEL OKR', value: 500 },
        { quarter: 'Q4', type: 'TAKIM OKR', value: 100 },
    ];

    const COLORS: Record<string, string> = {
        'GELİŞİM OKR': '#3CA0A6',
        'BİREYSEL OKR': '#0B2340',
        'TAKIM OKR': '#7EB3F5',
    };

    const config = {
        data,
        isStack: true,
        xField: 'quarter',
        yField: 'value',
        seriesField: 'type',
        color: Object.values(COLORS),
        legend: false,   // built-in legend kapalı
        tooltip: {
            showMarkers: false,
            formatter: datum => ({ name: datum.type, value: datum.value }),
        },
        xAxis: { label: { style: { fontSize: 12 } } },
        yAxis: {
            line: null,
            label: { style: { fontSize: 12 } },
            grid: { line: { style: { stroke: '#eee' } } },
        },
        padding: [40, 20, 40, 20],
    };

    return (
        <div className="h-full w-full p-4 bg-white rounded shadow flex flex-col">
            <h2 className="text-lg font-semibold text-center mb-4">OKR TAMAMLAMA ZAMANI</h2>

            {/* Custom Legend */}
            <div className="flex flex-wrap justify-center gap-6 mb-2 text-sm font-medium">
        <span className="flex items-center gap-1">
          <span className="w-3 h-3 rounded-full" style={{ background: COLORS['GELİŞİM OKR'] }} />
          GELİŞİM OKR
        </span>
                <span className="flex items-center gap-1">
          <span className="w-3 h-3 rounded-full" style={{ background: COLORS['BİREYSEL OKR'] }} />
          BİREYSEL OKR
        </span>
                <span className="w-full text-center mt-1"></span> {/* break line */}
                <span className="flex items-center gap-1">
          <span className="w-3 h-3 rounded-full" style={{ background: COLORS['TAKIM OKR'] }} />
          TAKIM OKR
        </span>
            </div>

            <Column {...config} />
        </div>
    );
};

export default OkrCompletionTimeWidget;
